import { Button, Header, HeaderActions, HeaderTitle, Logo, MenuIcon } from '@flysas-tech/react-components';
import { Form } from '@remix-run/react';

/**
 * SASHeader component.
 * @param {object} props - The component props.
 * @param {boolean} props.loggedIn - Shows if a user is logged in or not.
 * @param {Function} props.onMenu - The menu function.
 * @returns {import('react').ReactElement<Props>} - The SASHeader component.
 */
export default function SASHeader({ loggedIn, onMenu }) {
  /**
   * @param {import("react").MouseEvent} event - The event.
   */
  function handleMenuClick(event) {
    event.preventDefault();
    onMenu();
  }

  return (
    <Header className="min-h-[4.5rem]">
      {loggedIn && (
        <Button
          variant="primary"
          icon={<MenuIcon color="black" />}
          onClick={handleMenuClick}
          className="lg:hidden md:hidden"
        >
          Menu
        </Button>
      )}
      <HeaderTitle className="flex items-center gap-6">
        <Logo height="1.625rem" width="4.5rem" />
      </HeaderTitle>
      <HeaderActions>
        {loggedIn ? (
          <Form action="auth/logout" method="post">
            <Button>Log out</Button>
          </Form>
        ) : (
          <Form action="auth/auth0" method="post">
            <Button type="submit" variant="primary">
              Log in
            </Button>
          </Form>
        )}
      </HeaderActions>
    </Header>
  );
}
